import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Summary from '../components/Summary';
import PaymentButtons from '../components/PaymentButtons';
import { strings } from '../localization/strings';

const replaceLang = {
  it: 'ita',
  en: 'eng',
  fr: 'fra',
  de: 'de'
}

function PaymentData() {
  const location = useLocation();
  const state = location.state || { formData: [ {} ] };
  const [thankYouPageComplete, setThankYouPageComplete] = React.useState('');

  function useQuery() {
    return new URLSearchParams(location.search);
  }

  const query = useQuery();
  const language = query.get('lang') ?? 'it';
  const translation = strings[language] ?? strings.it;

  React.useEffect(() => {
    if (state.excursion?.thankYouPage) {
      let thankYouPage = state.excursion?.thankYouPage.replace('-ita', '-' + replaceLang[language]);
      if (thankYouPage && thankYouPage.startsWith('https') === false) {
        thankYouPage = state.excursion?.baseUrl + thankYouPage;
      }
      thankYouPage += '?clientName=' + state.formData[0].first_name + '&id=' + state.bookingTransactionId + "&email=" + state.formData[0].email;
      setThankYouPageComplete(thankYouPage);
    }
  }, [state.excursion, state.bookingTransactionId, state.formData, language]);
  
  return (
    <div className="tourmaster-page-wrapper tourmaster-payment-style-1 tourmaster-template-payment" id="tourmaster-page-wrapper">
        <Header currentStep="3" tourName={state.excursionName} language={language} tourUrl={state?.excursionUrl}/>
        <div className="tourmaster-template-wrapper" id="tourmaster-payment-template-wrapper">
          <div className="tourmaster-container">
            <div className="tourmaster-page-content tourmaster-item-pdlr clearfix">              
              <div className="tourmaster-tour-payment-content" id="tourmaster-tour-payment-content">
                <div className="tourmaster-form-field tourmaster-with-border">
                  <h5 style={{color: '#a3a3a3'}}>{translation.paymentMethod}:</h5>
                  <PaymentButtons availability={state.availability} adult={state.inputs.adult} child={state.inputs.child} bookingRequestId={state.bookingRequestId} transactionId={state.bookingTransactionId} thankYouPage={thankYouPageComplete} language={language}/>
                </div>
              </div>
              <Summary availability={state.availability} tourName={state.excursionName} date={state.inputs.uiDate} adult={state.inputs.adult} child={state.inputs.child} baby={state.inputs.baby} language={language} excludeFree={state?.excursion?.excludeFree}/>
            </div>
          </div>
        </div>
    </div>
  );
}

export default PaymentData;